import React from 'react'
import { Link } from 'react-router-dom'
import { Tag, Spin, Button } from 'antd'
import _get from 'lodash/get'
import { inject, observer } from 'mobx-react'
import { graphql } from 'react-apollo'
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
// import { Link, Redirect } from 'react-router-dom'
import OrderItemModal from '~/App/components/OrderItemModal'
import ProductSelectModal from '~/App/components/ProductSelectModal'
import OrderSteps from '~/App/components/OrderSteps'
import addOrderItemMutation from '~/App/graphql/mutations/addOrderItem.gql'
import orderQuery from '~/App/graphql/queries/order.gql'
import ExtraItems from '~/App/components/ExtraItems'
import localeGet from '~/App/utils/localeGet'
@inject('i18n')
@inject('router')
// @Form.create()
@injectIntl
@graphql(orderQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { _id: id }
  })
})
@graphql(addOrderItemMutation, {
  name: 'addOrderItem'
})
@observer
class Order extends React.Component {
  state = {
    // submitting: false
  }
  handleAddOrderItem = async (orderItem) => {
    const { match: { params: { id } } } = this.props
    const { location } = this.props.router
    await this.props.addOrderItem({
      variables: {
        record: orderItem
      }, // TODO: writeQuery
      refetchQueries: [{ // can use updateQuery
        query: orderQuery,
        variables: {
          _id: id
        }
      }]
    })
    location.query = {
      ...location.query,
      pdId: 'select'
    }
  }
  componentDidMount () {
    const { data } = this.props
    const order = _get(data, 'order')
    if (order && order.status !== 'paid') {
      this.props.history.replace(`/orders/${order._id}/edit`)
    }
  }
  handleSelectProduct = () => {
    const { location } = this.props.router
    location.query = {
      ...location.query,
      pdId: 'select'
    }
  }

  // handleSelectProductItem = (e) => {
  //   // e.preventDefault()
  //   const { productTypeIds: pItemIds } = this.state
  //   let productTypeIds
  //   if (e.target.checked) {
  //     productTypeIds = pItemIds.concat(e.target.value)
  //   } else {
  //     productTypeIds = pItemIds.filter(item => item !== e.target.value)
  //   }
  //   this.setState({ productTypeIds })
  // }
  render () {
    const {
      data,
      i18n: { locale }
    } = this.props

    if (data.loading) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }
    if (!data.order) {
      return <div>Order not found...</div>
    }
    const order = _get(data, 'order')
    const amount = _get(data, 'order.amount')
    const registration = _get(data, 'order.registration')
    const event = _get(data, 'order.event')
    const { pdId } = this.props.router.location.query
    return <div className="EventRegisterPage">
      <div className="innerEventRegisterPage" >
        <div className="dividedBox">
          <div className="registrationTopTitle">
            {localeGet(data, 'order.event.name', locale)}
          </div>
          <OrderSteps step="complete"/>
        </div>
        <div className="dividedBox">
          <h1><FormattedMessage id="app.extraItems" /></h1>
          <div><FormattedMessage id="app.orderCode" /> : {order.code}</div>
          <div style={{ paddingBottom: '8px' }}>
            <Tag color="green"><FormattedNumber value={_get(amount, 'discounted')}/> THB ({
              <FormattedMessage id="paymentStatus.paid" defaultMessag="Paid" />
            })</Tag>
          </div>
          <div>
            {order.items.length > 0 && <ExtraItems items={order.items} locale={locale} event={event}/>}
          </div>
          <div style={{ paddingTop: '8px', textAlign: 'right' }}>
            <Link to={`/reg/${registration._id}`}>
              <Button>รายละเอียดใบสมัคร</Button>
            </Link>
          </div>
        </div>
      </div>
      {pdId === 'select' && <ProductSelectModal registrationId={registration._id} onAddOrderItem={this.handleAddOrderItem}/>}
      {!!pdId && pdId !== 'select' &&
        <OrderItemModal
          event={event}
          registrationId={registration._id}
          masterId={order._id}
          masterType="Order"
          productId={pdId}
          onAddOrderItem={this.handleAddOrderItem }
        />
      }
    </div>
  }
}

export default Order



// WEBPACK FOOTER //
// ./src/App/pages/Order/Order.js